import PropTypes from 'prop-types';
import React from 'react';
import b_ from 'b_';
import FusePopUp from '../FuseControls/FusePopUp';
import Actions from '../Actions/Actions';
import FuseButton from '../FuseControls/FuseButton';
import './FuseConfirmationModal.css';

const block = b_.lock('FuseConfirmationModal');
export default function FuseModalLayout({
    children,
    isOpen,
    title,
    hideLeftBtn,
    leftBtnLabel,
    leftBtnProps,
    rightBtnLabel,
    rightBtnProps }) {
    return <FusePopUp
        className={block()}
        isOpen={isOpen}
        title={title}
    >
        {children}
        <Actions className={block('Actions')}>
            {!hideLeftBtn && <FuseButton
                className={block('ConfirmButton')}
                {...leftBtnProps}
            >{leftBtnLabel}</FuseButton>}

            <FuseButton
                className={block('CancelButton')}
                {...rightBtnProps}
            >{rightBtnLabel}</FuseButton>
        </Actions>
    </FusePopUp>;
}
FuseModalLayout.defaultProps = {
    hideLeftBtn: false,
};
FuseModalLayout.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    leftBtnLabel: PropTypes.string,
    rightBtnLabel: PropTypes.string,
    title: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    ...FuseButton.propTypes,
};
